import { useState } from "react";

const ProfessionalExperience = ({ userDetails }) => {
  // Build experiences array with CORRECT PascalCase field names
  const allExperiences = [];
  for (let i = 1; i <= 10; i++) {
    const title = userDetails[`PositionProfessionalExperience${i}`] || "";
    const company = userDetails[`CompanyProfessionalExperience${i}`] || "";
    const duration = userDetails[`YearProfessionalExperience${i}`] || "";
    if (title || company || duration) {
      allExperiences.push({ title, company, duration });
    }
  }

  // Build education array with all 10 slots
  const allEducation = [];
  for (let i = 1; i <= 10; i++) {
    const degree = userDetails[`EducationDegree${i}`] || "";
    const institute = userDetails[`EducationalInstitute${i}`] || "";
    const year = userDetails[`EducationYear${i}`] || "";
    const title = userDetails[`EducationTitle${i}`] || "";
    if (degree || institute || year || title) {
      allEducation.push({ degree, institute, year, title });
    }
  }

  const [visibleExpCount, setVisibleExpCount] = useState(3);
  const [visibleEduCount, setVisibleEduCount] = useState(3);
  const [showAllExperience, setShowAllExperience] = useState(false);
  const [showAllEducation, setShowAllEducation] = useState(false);

  const handleLoadMoreExp = () => {
    setShowAllExperience(true);
    setVisibleExpCount(allExperiences.length);
  };

  const handleViewLessExp = () => {
    setShowAllExperience(false);
    setVisibleExpCount(3);
  };

  const handleLoadMoreEdu = () => {
    setShowAllEducation(true);
    setVisibleEduCount(allEducation.length);
  };

  const handleViewLessEdu = () => {
    setShowAllEducation(false);
    setVisibleEduCount(3);
  };

  return (
    <>
      <div className="lg:px-40 mt-10 mb-10">
        <div className="bg-gray-50">
          <div className="grid grid-cols-2 divide-x p-4">
            <div className="px-10">
              <div className="flex items-center mb-5 gap-6">
                <h1 className="font-bold">Experience</h1>
                {allExperiences.length > 3 && (
                  showAllExperience ? (
                    <p
                      onClick={handleViewLessExp}
                      className="underline text-sm text-blue-600 cursor-pointer"
                    >
                      View less
                    </p>
                  ) : (
                    <p
                      onClick={handleLoadMoreExp}
                      className="underline text-sm text-blue-600 cursor-pointer"
                    >
                      View all ({allExperiences.length})
                    </p>
                  )
                )}
              </div>
              <section className="text-gray-600 body-font">
                <div className="container mx-auto">
                  {allExperiences.length === 0 ? (
                    <p className="text-sm text-gray-400">No experience data available.</p>
                  ) : (
                    allExperiences.slice(0, visibleExpCount).map((exp, index) => (
                      <div key={index} className="mb-3 flex items-start">
                        <div className="w-2 h-2 rounded-full mt-2 mr-4 bg-gray-400 flex-shrink-0"></div>
                        <div className="flex-grow text-sm">
                          {exp.title && (
                            <h2 className="font-bold text-gray-900">
                              {exp.title}
                            </h2>
                          )}
                          {exp.company && (
                            <p className="leading-relaxed">{exp.company}</p>
                          )}
                          {exp.duration && <p>{exp.duration}</p>}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </section>
            </div>
            <div className="px-20">
              <div className="flex items-center mb-5 gap-6">
                <h1 className="font-bold">Education</h1>
                {allEducation.length > 3 && (
                  showAllEducation ? (
                    <p
                      onClick={handleViewLessEdu}
                      className="underline text-sm text-blue-600 cursor-pointer"
                    >
                      View less
                    </p>
                  ) : (
                    <p
                      onClick={handleLoadMoreEdu}
                      className="underline text-sm text-blue-600 cursor-pointer"
                    >
                      View all ({allEducation.length})
                    </p>
                  )
                )}
              </div>
              <section className="text-gray-600 body-font">
                <div className="container mx-auto">
                  {allEducation.length === 0 ? (
                    <p className="text-sm text-gray-400">No education data available.</p>
                  ) : (
                    allEducation.slice(0, visibleEduCount).map((edu, index) => (
                      <div key={index} className="mb-3 flex items-start">
                        <div className="w-2 h-2 rounded-full mt-2 mr-4 bg-gray-400 flex-shrink-0"></div>
                        <div className="flex-grow text-sm">
                          {edu.degree && (
                            <h2 className="font-bold text-gray-900">
                              {edu.degree}
                            </h2>
                          )}
                          {edu.title && (
                            <p className="leading-relaxed font-medium">{edu.title}</p>
                          )}
                          {edu.institute && (
                            <p className="leading-relaxed">{edu.institute}</p>
                          )}
                          {edu.year && <p>{edu.year}</p>}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfessionalExperience;
